'use client';

import React from 'react';
import { ExclamationCircle } from 'react-bootstrap-icons'; // optional icon library

interface ErrorProps {
    error: Error;
    reset?: () => void;
}

const ErrorComponent: React.FC<ErrorProps> = ({ error, reset }) => {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center p-3">
            <div className="card shadow-sm" style={{ maxWidth: '500px', width: '100%' }}>
                <div className="card-body">
                    <div className="mb-3">
                        <ExclamationCircle size={48} className="text-danger" />
                    </div>
                    <h3 className="card-title mb-2">Oops! Something went wrong</h3>
                    <p className="card-text text-muted">
                        {error?.message || 'An unexpected error occurred. Please try again.'}
                    </p>
                    {reset && (
                        <button className="btn btn-primary mt-3" onClick={reset}>
                            Retry
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ErrorComponent;
